import React from 'react';
import { Box } from '@mui/material';
import NavBar from '../components/navbar';
import Footer from '../components/footer';
import CtaSection from '../components/CtaSection';
import ResilienceHero from '../components/home/ResilienceHero';
import WorldChanged from '../components/home/WorldChanged';
import EcosystemSection from '../components/home/EcosystemSection';
import AeraPreview from '../components/home/AeraPreview';
import CapabilitiesGrid from '../components/home/CapabilitiesGrid';
import IndustriesStrip from '../components/home/IndustriesStrip';
import TechnologyTeaser from '../components/home/TechnologyTeaser';
import InsightsTeaser, { CaseStudiesSection } from '../components/home/InsightsAndCases';
import IrdaCertificateSection from '../components/home/IrdaCertificateSection';
import {
  ClientsMarquee,
  TestimonialsSection,
} from '../components/home/HomeClosing';
import MagneticButton from '../components/animated/MagneticButton';
import ScrollReveal from '../components/animated/ScrollReveal';
import BrandTagline from '../components/BrandTagline';
import { colors, gradients } from '../theme/designTokens';
import Text from '../components/Text';

const Home = () => (
  <Box sx={{ bgcolor: colors.white, overflow: 'hidden' }}>
    <NavBar dark />
    <ResilienceHero />

    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 5, md: 7 },
        background: colors.white,
        borderBottom: `1px solid ${colors.borderLight}`,
      }}
    >
      <ScrollReveal>
        <Box sx={{ maxWidth: 720, mx: 'auto', textAlign: 'center' }}>
          <BrandTagline variant="light" align="center" banner compact={false} />
        </Box>
      </ScrollReveal>
    </Box>

    <IrdaCertificateSection />

    <WorldChanged />
    <EcosystemSection />
    <AeraPreview />

    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 6, md: 8 },
        background: gradients.sectionDark,
        textAlign: 'center',
      }}
    >
      <ScrollReveal>
        <Text variant="eyebrow" sx={{ color: colors.ochre, mb: 2, display: 'block' }}>
          ERM Efficiency Index
        </Text>
        <Text variant="h2" color="white" sx={{ mb: 2 }}>
          Measure enterprise risk maturity.
        </Text>
        <Text variant="body" color="muted" sx={{ mb: 4, display: 'block', maxWidth: 520, mx: 'auto' }}>
          Explore ALEgION&apos;s proprietary index—board-ready scoring across six pillars of ERM efficiency.
        </Text>
        <MagneticButton
          variant="gold"
          component="a"
          href="https://erm.alegion.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Try ERM Efficiency Index
        </MagneticButton>
      </ScrollReveal>
    </Box>

    <CapabilitiesGrid />
    <IndustriesStrip />
    <TechnologyTeaser />
    <InsightsTeaser />
    <CaseStudiesSection />
    <ClientsMarquee />
    <TestimonialsSection />
    <CtaSection
      title="Begin the resilience conversation."
      subtitle="Simple. Elegant. Ready when you are."
      primaryLabel="Contact ALEgION"
      primaryPath="/contact"
      secondaryLabel="Explore AERA™"
      secondaryPath="/framework"
    />
    <Footer />
  </Box>
);

export default Home;
